module.exports = __webpack_public_path__ + "img/l.470855e2.jpg";